export default __webpack_public_path__ + "static/media/milestone-logo-small.bbfec916.svg";